// =============================================================================
// Storage Service (HTTP-based, backend-proxied)
// =============================================================================
// This file maintains compatibility with existing code that imports from supabaseStorage
// Now uses HTTP-based uploads through backend API instead of direct MinIO client

import { storageService } from './storageService';

// Export storage service with Supabase-compatible names for backward compatibility
export const supabase = {
  storage: storageService
};

export const supabaseStorage = storageService;

// Export default for backward compatibility
export default storageService;
